__webpack_require__.p = (typeof globalThis !== 'undefined' ? globalThis : window).publicPath || '/';